export const GLOBO_CUSTOMER_ID = parseInt(process.env.REACT_APP_GLOBO_CUSTOMER_ID);
